import { forwardRef } from "react"
import { classes } from "utils"

export const ImageButton = forwardRef(
  (
    { className, icon, disabled, tooltip, iconStyle, ...props },
    ref,
  ) => (
    <button
      type="button"
      title={tooltip}
      aria-label="action-button"
      className={classes(className, "button")}
      ref={ref}
      css={{
        cursor: disabled ? "not-allowed" : "pointer",
        border: "none",
        background: "transparent",
        borderRadius: 4,
        width: 40,
        height: 40,
        ":hover": {
          opacity: 0.85,
        },
        ":active": {
          opacity: 1,
        },
      }}
      disabled={disabled}
      {...props}
    >
      <img
        className="button-image"
        alt="button-image"
        src={icon}
        css={[{ cursor: disabled ? "not-allowed" : "pointer" }, iconStyle]}
      />
    </button>
  ),
)

ImageButton.displayName = "ImageButton"
